module.exports = __webpack_public_path__ + "static/media/logo.824b94e7.png";